import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { InfoModalInterface } from '../models';

@Component({
  selector: 'nx-ng-info-modal',
  templateUrl: './info-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalComponent implements OnInit {
  title = '';
  markdown = '';
  showTicket = false;

  constructor(
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoModalInterface,
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title;
    this.markdown = this.data?.markdown;
    this.showTicket = this.data?.showTicket;
  }

  get translatedMarkdown() {
    const translatedMd = this.i18n.t(this.markdown, {
      ns: ['tickets', 'translation'],
    });

    return translatedMd === this.markdown ? '' : translatedMd;
  }
}
